<p>auth operator dashboard works!</p>